import { TransactionsDetailModal } from '@/modules/projects'
import type { MerchantStat, Transaction } from '@/modules/projects/stores/types'
import { MetadataPanel } from './MetadataPanel'

interface MerchantDetailModalProps {
  merchant: MerchantStat | null
  matchedTransactions: Transaction[]
  onOpenChange: (open: boolean) => void
}

export function MerchantDetailModal({
  merchant,
  matchedTransactions,
  onOpenChange,
}: MerchantDetailModalProps) {
  const description =
    matchedTransactions.length === 0
      ? 'No transactions matched for this merchant.'
      : `${matchedTransactions.length} transaction${matchedTransactions.length === 1 ? '' : 's'} matched for this merchant.`

  return (
    <TransactionsDetailModal
      open={!!merchant}
      onOpenChange={onOpenChange}
      title={
        merchant ? (
          <span className="capitalize">{merchant.merchantGroup}</span>
        ) : (
          ''
        )
      }
      description={merchant ? description : ''}
      transactions={matchedTransactions}
      contextId="merchants-detail"
      exportFilename="merchant-transactions"
      metadata={
        merchant && (
          <MetadataPanel
            merchant={merchant}
            matchedCount={matchedTransactions.length}
          />
        )
      }
    />
  )
}
